import { Injectable } from '@angular/core';
import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import { map } from 'rxjs/operators';

import { Orgao } from '../models/orgao.model';

import { AuthService } from 'src/app/auth/services/auth.service';

import { dateTimeCurrent } from 'src/app/shared/functions/date-time-functions';

import * as _ from 'lodash';
import { LogData } from '../models/log-data.model';

@Injectable({
  providedIn: 'root'
})
export class OrgaoService {
  private orgaoRef = this.db.list<Orgao>('orgaos',
    ref => ref.orderByChild('sigla')
  );

  constructor(private db: AngularFireDatabase, private auth: AuthService) { }

  getAll() {
    return this.orgaoRef.snapshotChanges().pipe(
      map(changes =>
        changes.map(c => ({ key: c.payload.key, ...c.payload.val() }))
      )
    );
  }

  getOrgao(key: string) {
    return this.db.object<Orgao>(`orgaos/${ key }`).snapshotChanges().pipe(
      map(data => {
        return { key: data.payload.key, ...data.payload.val() };
      })
    );
  }

  create(orgao: Orgao) {
    orgao.enabled = true;
    orgao.logData = this.getLogData(orgao);

    return this.orgaoRef.push(orgao);
  }

  update(orgao: Orgao) {
    orgao.logData = this.getLogData(orgao);

    return this.orgaoRef.update(orgao.key, _.omit(orgao, ['key']));
  }

  remove(orgao: Orgao) {
    return this.orgaoRef.remove(orgao.key);
  }

  private getLogData(orgao: Orgao): LogData {
    const logData = {
      createdAt: orgao.logData && orgao.logData.createdAt ? orgao.logData.createdAt : dateTimeCurrent(),
      updatedAt: dateTimeCurrent(),
      userKey: this.auth.user.uid,
      user: this.auth.user.nome,
      userConhecidoComo: this.auth.user.conhecidoComo
    };

    return logData;
  }
}
